import React, { useEffect } from 'react';
// import ObjectsReestrView from '../components/contents/ObjectsReestrView';
import ObjectsReestrView from '../components/contents/ObjectsReestrViewV3';

const ObjectsReestrPageV3 = () => {

  useEffect(() => {
    document.title = "Реестр объектов";
}, []);

  return (
    <ObjectsReestrView />
  );
};

export default ObjectsReestrPageV3; 